module.exports = "/_next/static/images/4-1-5cbcfc794637c97fcaca375d159ef329.svg";